import React, { useState, useEffect } from 'react';

import { addAllList } from 'modules/common';
import { getMediaTpCodeList } from 'lib/api/code';

import FilterCollection from 'components/organisms/FilterCollection';

import { useTranslation } from 'react-i18next';

const NewCommonFilter = (props) => {
  const { t } = useTranslation();
  const {
    label = t('매체 카테고리'),
    name = 'crgrNo',
    params,
    value,
    type = 'select',
    callBack = (f) => f,
    labelKey = 'CODE_VAL',
    valueKey = 'CODE_ID',
  } = props;

  const [filterList, setFilterList] = useState([]);

  useEffect(() => {
    getMediaTpCodeList()
      .then((response) => {
        setFilterList(
          addAllList(response.data.data, 'CODE_VAL', 'CODE_ID', 'all')
        );
      })
      .catch((error) => {
        alert(error);
      });
    // eslint-disable-next-line
  }, [getMediaTpCodeList]);

  return (
    <>
      {filterList.length > 0 && (
        <FilterCollection
          label={label}
          name={name}
          params={params}
          value={value}
          type={type}
          list={filterList}
          callBack={callBack}
          labelKey={labelKey}
          valueKey={valueKey}
        />
      )}
    </>
  );
};

export default NewCommonFilter;
